import { render, staticRenderFns } from "./OogCargoChkPop.vue?vue&type=template&id=858769e4&scoped=true"
import script from "./OogCargoChkPop.vue?vue&type=script&lang=js"
export * from "./OogCargoChkPop.vue?vue&type=script&lang=js"
import style0 from "./OogCargoChkPop.vue?vue&type=style&index=0&id=858769e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858769e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('858769e4')) {
      api.createRecord('858769e4', component.options)
    } else {
      api.reload('858769e4', component.options)
    }
    module.hot.accept("./OogCargoChkPop.vue?vue&type=template&id=858769e4&scoped=true", function () {
      api.rerender('858769e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OogCargoChkPop.vue"
export default component.exports